import { localePrefixes } from '@/i18n/domainConfig';
import { buildCrossDomainUrl } from '@/utility/buildCrossDomainUrl';
import { Locale } from '@/utility/locale';

export const getCheckoutUrl = (cartId: string, locale: Locale) => {
  if (typeof window === 'undefined') return '';

  const localePrefix = localePrefixes[locale];
  const path = `${localePrefix ? `/${localePrefix}` : ''}/${cartId}`;

  return buildCrossDomainUrl('checkout-ct', path);
};
